/**
 * KosherMarket — Smart ZIP Geolocation
 * v4.1 — IP-based geolocation + ZIP shown in button
 */

(function () {
  'use strict';

  var LS_ZIP   = 'visitor_zip';
  var LS_SHOWN = 'popUpShown';
  var LS_TIME  = 'lastPopUpTime';

  /* ────────────────────────────────────────────────
     Локализация — строки берутся из window.kmZipStrings
     (заполняется в layout/theme.liquid через {{ 'km_zip.xxx' | t }},
     подхватывает язык страницы). Английский текст здесь — fallback
     на случай, если объект почему-то не создался.
  ─────────────────────────────────────────────── */
  var STR = window.kmZipStrings || {};
  function S(key, fallback) {
    return (STR && STR[key]) || fallback;
  }

  /* ────────────────────────────────────────────────
     БЛОК 1 — Hide Shipturtle popup + button
  ─────────────────────────────────────────────── */
  function hideShipturtleAll() {
    var divs = document.querySelectorAll('div');
    for (var i = 0; i < divs.length; i++) {
      var t = divs[i].textContent || '';
      if (
        t.indexOf('currently Berlin') !== -1 &&
        t.indexOf('Some products are only available') !== -1 &&
        divs[i].offsetParent !== null
      ) {
        var box = divs[i];
        while (
          box.parentElement &&
          (box.parentElement.textContent || '').indexOf('currently Berlin') !== -1 &&
          box.parentElement.children.length <= 3
        ) {
          box = box.parentElement;
        }
        box.style.setProperty('display', 'none', 'important');
      }
    }
    var stBtn = document.getElementById('zipcode-change-button');
    if (stBtn) stBtn.style.setProperty('display', 'none', 'important');
  }

  var _attempts = 0;
  hideShipturtleAll();
  var _hider = setInterval(function () {
    _attempts++;
    hideShipturtleAll();
    if (_attempts >= 60) clearInterval(_hider);
  }, 200);


  /* ────────────────────────────────────────────────
     БЛОК 5 — Our popup UI + Change ZIP button
  ─────────────────────────────────────────────── */
  function updateChangeBtnLabel() {
    var btn = document.getElementById('km-zip-change');
    if (!btn) return;
    var zip = localStorage.getItem(LS_ZIP);
    btn.textContent = zip
      ? ('📍 ' + zip + ' · ' + S('change', 'Change'))
      : S('enterZipCode', 'Enter ZIP Code');
  }

  function injectUI() {
    if (document.getElementById('km-zip-overlay')) return;

    var style = document.createElement('style');
    style.textContent = [
      '#km-zip-overlay{',
        'display:none;position:fixed;top:0;left:0;width:100%;height:100%;',
        'background:rgba(0,0,0,0.55);z-index:2147483647;',
        'align-items:center;justify-content:center;',
      '}',
      '#km-zip-box{',
        'background:#fff;border-radius:12px;padding:32px 28px;',
        'max-width:380px;width:90%;text-align:center;font-family:sans-serif;',
        'box-shadow:0 8px 32px rgba(0,0,0,0.18);',
      '}',
      '#km-zip-box h3{margin:0 0 10px;font-size:18px;color:#1a1a1a;}',
      '#km-zip-box p{margin:0 0 20px;font-size:14px;color:#555;line-height:1.5;}',
      '#km-zip-input{',
        'width:100%;box-sizing:border-box;padding:11px 14px;',
        'border:1.5px solid #ccc;border-radius:8px;font-size:16px;',
        'outline:none;margin-bottom:12px;',
      '}',
      '#km-zip-input:focus{border-color:#2e7d32;}',
      '#km-zip-submit{',
        'width:100%;padding:12px;background:#2e7d32;color:#fff;',
        'border:none;border-radius:8px;font-size:16px;cursor:pointer;',
      '}',
      '#km-zip-submit:hover{background:#1b5e20;}',
      '#km-zip-error{color:#c0392b;font-size:13px;margin-top:6px;min-height:18px;}',
      '#km-zip-change{',
        'position:fixed;bottom:20px;right:20px;',
        'background:#2e7d32;color:#fff;border:none;border-radius:24px;',
        'padding:10px 18px;font-size:13px;cursor:pointer;z-index:2147483648;',
        'box-shadow:0 2px 8px rgba(0,0,0,0.2);white-space:nowrap;',
      '}',
      '#km-zip-change:hover{background:#1b5e20;}'
    ].join('');
    document.head.appendChild(style);

    var overlay = document.createElement('div');
    overlay.id = 'km-zip-overlay';
    overlay.innerHTML = [
      '<div id="km-zip-box">',
        '<h3 id="km-zip-title"></h3>',
        '<p id="km-zip-desc"></p>',
        '<input id="km-zip-input" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="10" />',
        '<button id="km-zip-submit"></button>',
        '<div id="km-zip-error"></div>',
      '</div>'
    ].join('');
    document.body.appendChild(overlay);

    document.getElementById('km-zip-title').textContent =
      S('popupTitleEnter', '📍 Enter your ZIP code');
    document.getElementById('km-zip-desc').textContent = S(
      'popupDescEnter',
      'Some products are only available in certain delivery areas. Please enter your postal code to see products available near you.'
    );
    document.getElementById('km-zip-input').setAttribute(
      'placeholder',
      S('inputPlaceholder', 'e.g. 10115')
    );
    document.getElementById('km-zip-submit').textContent =
      S('submitButton', 'Show available products');

    var changeBtn = document.createElement('button');
    changeBtn.id = 'km-zip-change';
    document.body.appendChild(changeBtn);
    updateChangeBtnLabel();

    document.getElementById('km-zip-submit').addEventListener('click', handleSubmit);
    document.getElementById('km-zip-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') handleSubmit();
    });
    changeBtn.addEventListener('click', function () {
      showPopup(
        S('popupTitleChange', '📍 Change your ZIP code'),
        S('popupDescChange', 'Enter a new postal code to update the products available in your area.')
      );
    });
  }

  function showPopup(title, desc) {
    var overlay = document.getElementById('km-zip-overlay');
    if (!overlay) return;
    if (title) document.getElementById('km-zip-title').textContent = title;
    if (desc)  document.getElementById('km-zip-desc').textContent  = desc;
    document.getElementById('km-zip-error').textContent = '';
    document.getElementById('km-zip-input').value = '';
    overlay.style.display = 'flex';
    setTimeout(function () {
      document.getElementById('km-zip-input').focus();
    }, 100);
  }

  function hidePopup() {
    var overlay = document.getElementById('km-zip-overlay');
    if (overlay) overlay.style.display = 'none';
  }

  function handleSubmit() {
    var val = (document.getElementById('km-zip-input').value || '').trim();
    var errEl = document.getElementById('km-zip-error');
    if (!val || val.length < 4) {
      errEl.textContent = S('errorInvalid', 'Please enter a valid postal code.');
      return;
    }
    var validZips = window.KM_VALID_ZIPS;
    if (validZips && validZips.length > 0) {
      if (validZips.indexOf(val) === -1) {
        errEl.textContent = S('errorOutsideZone', 'Sorry, delivery is not available in your area.');
        return;
      }
    }
    saveZipAndReload(val);
  }

  function saveZipAndReload(zip) {
    localStorage.setItem(LS_ZIP,   zip);
    localStorage.setItem(LS_SHOWN, '1');
    localStorage.setItem(LS_TIME,  Date.now().toString());
    hidePopup();
    location.reload();
  }


  /* ────────────────────────────────────────────────
     БЛОК 2.5 — Delivery zone ranges (coarse check)
     Not full ZIP validation (that stays with ShipTurtle /
     kms.zips per-vendor lists) — just a guard so an IP-guessed
     ZIP from outside all delivery zones is never silently
     applied. Add a new { name, test } entry here when a new
     country/city zone is added.
  ─────────────────────────────────────────────── */
  // Точные списки реальных ZIP из kms.zips_berlin / kms.zips_cyprus (все
  // активные вендоры каждой зоны дают идентичный список — сверено по
  // Lampari/KosherMarket Personal Shopper/Judaica/KOSHER GOLD Premium Vodka
  // для Берлина и GlattShop/Sambation Kosher для Кипра). Точнее, чем диапазон
  // po числу — не даёт ложных совпадений на "дырах" внутри диапазона.
  // Обновлять этот список при изменении реальных зон доставки в kms.zips_*.
  var KM_BERLIN_ZIPS = [
    '10115','10117','10119','10178','10179','10435','10437','10439','10551','10553',
    '10555','10557','10559','10585','10587','10589','10623','10625','10627','10629',
    '10707','10709','10711','10713','10715','10717','10719','10777','10779','10781',
    '10783','10785','10787','10789','10823','10825','10827','10829','10961','10963',
    '10965','10967','10969','10997','10999','12043','12047','12049','12051','12053',
    '12099','12101','12103','12105','12157','12159','12161','12163','12165','12167',
    '12169','12203','12205','12207','12209','12247','12249','13347','13351','13353',
    '13355','13357','13359','13403','13405','13407','13409','13581','13583','13585',
    '13593','13595','13597','13627','13629','14050','14052','14053','14055','14057',
    '14059','14129','14163','14165','14167','14169','14193','14195','14197','14199'
  ];

  var KM_CYPRUS_ZIPS = [
    '6010','6011','6012','6013','6015','6016','6017','6018','6019','6020',
    '6021','6022','6023','6025','6026','6027','6028','6030','6031','6035',
    '6036','6037','6040','6041','6042','6043','6045','6046','6047','6050',
    '6051','6052','6053','6055','6056','6057','6058','6059','7020','7041',
    '7060','7080','7081','7100','7101','7102','7103','7104','7550','7560'
  ];

  var KM_ZONE_RANGES = [
    { name: 'berlin', test: function (z) { return KM_BERLIN_ZIPS.indexOf(z) !== -1; } },
    { name: 'cyprus', test: function (z) { return KM_CYPRUS_ZIPS.indexOf(z) !== -1; } }
  ];

  function isZipInAnyZone(zip) {
    for (var i = 0; i < KM_ZONE_RANGES.length; i++) {
      if (KM_ZONE_RANGES[i].test(zip)) return true;
    }
    return false;
  }


  /* ────────────────────────────────────────────────
     БЛОК 3 — IP Geolocation
     ipapi.co — free, no API key, no permission
  ─────────────────────────────────────────────── */
  function resolveZipByIP() {
    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var zip = data && data.postal;
        if (zip && zip.length >= 4 && isZipInAnyZone(zip)) {
          saveZipAndReload(zip);
        } else {
          showPopup(
            S('popupTitleEnter', '📍 Enter your ZIP code'),
            S('popupDescIpFallback', 'Please enter your postal code to see products available for delivery in your area.')
          );
        }
      })
      .catch(function () {
        showPopup(
          S('popupTitleEnter', '📍 Enter your ZIP code'),
          S('popupDescIpFallback', 'Please enter your postal code to see products available for delivery in your area.')
        );
      });
  }


  /* ────────────────────────────────────────────────
     БЛОК 6 — Inline ZIP badge on "not available in
     your area" message. Runs on normal page load AND
     after AJAX navigation (km:ajaxCollectionLoaded),
     since inline <script> in the AJAX-swapped HTML
     never executes.
  ─────────────────────────────────────────────── */
  function updateInlineZipBadge() {
    var el = document.getElementById('km-zip-inline-current');
    if (!el) return;
    var zip = localStorage.getItem(LS_ZIP);
    if (!zip) { el.innerHTML = ''; return; }
    var changeLabel = S('change', 'Change');
    el.innerHTML = '📍 ' + zip +
      ' · <button type="button" id="km-zip-inline-change" ' +
      'style="background:none;border:none;padding:0;color:#2e7d32;' +
      'text-decoration:underline;cursor:pointer;font:inherit;">' + changeLabel + '</button>';
    var btn = document.getElementById('km-zip-inline-change');
    if (btn) {
      btn.addEventListener('click', function () {
        var mainBtn = document.getElementById('km-zip-change');
        if (mainBtn) mainBtn.click();
      });
    }
  }

  updateInlineZipBadge();
  window.addEventListener('km:ajaxCollectionLoaded', updateInlineZipBadge);


  /* ────────────────────────────────────────────────
     START
  ─────────────────────────────────────────────── */
  function init() {
    injectUI();
    if (!localStorage.getItem(LS_ZIP)) {
      resolveZipByIP();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
